export default {
  dadosCadastrais: state => state.dadosCadastrais
};
